import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "primary-container mt-4"
}
const _hoisted_2 = { class: "py-16 px-6 rounded-xl bg-white border border-gray-200" }
const _hoisted_3 = { class: "text-center mb-4" }
const _hoisted_4 = { class: "text-gray-900 font-medium text-2xl" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "text-center flex flex-row justify-center items-center flex-wrap mb-6" }
const _hoisted_7 = { class: "h-5 w-5 me-2" }
const _hoisted_8 = { class: "h-5 w-5 me-2" }
const _hoisted_9 = { class: "h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = { class: "text-center flex flex-row justify-center items-center flex-wrap mb-6" }
const _hoisted_12 = { class: "h-5 w-5 me-2" }
const _hoisted_13 = { class: "h-5 w-5 me-2" }
const _hoisted_14 = { class: "h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5" }
const _hoisted_15 = { class: "primary-container" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5" }

import { ref, computed } from "vue";
import ArchiveSchoolGroupComponent from "./ArchiveSchoolGroupComponent.vue";
import ArchiveSchoolComponent from "./ArchiveSchoolComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ArchiveSelectionComponent',
  setup(__props) {

const menuToggle = ref("");

const showInitialComponent = () => {
    menuToggle.value = "";
}

const actionType = computed(() => {
    const archive = ["school-group-archive", "school-archive"];
    const unarchive = ["school-group-unarchive", "school-unarchive"];
    if (archive.includes(menuToggle.value)) {
        return "Archive";
    } else if (unarchive.includes(menuToggle.value)) {
        return "Unarchive";
    }
    return "";
});


return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (menuToggle.value == '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('internal_tools.archive_selection_component.title')), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('internal_tools.archive_selection_component.subtitle')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (menuToggle.value = 'school-group-archive')),
                class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white mt-4 mx-2 flex flex-row justify-center items-center flex-wrap"
              }, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-school-group',
                    title: 'rl school group',
                    "aria-hidden": "true"
                  })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('internal_tools.archive_selection_component.archive_school_groups')), 1)
              ]),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (menuToggle.value = 'school-archive')),
                class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white mt-4 mx-2 flex flex-row justify-center items-center flex-wrap"
              }, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-archive-school',
                    title: 'rl archive school',
                    "aria-hidden": "true"
                  })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('internal_tools.archive_selection_component.archive_schools')), 1)
              ]),
              _createVNode(_component_router_link, {
                to: "/main/internal-achive",
                class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white mt-4 mx-2 flex flex-row justify-center items-center flex-wrap"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_rl_icon, {
                      icon: 'rl-learners-icon',
                      title: 'rl learners icon',
                      "aria-hidden": "true"
                    })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('internal_tools.archive_selection_component.archive_learners')), 1)
                ]),
                _: 1
              })
            ]),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (menuToggle.value = 'school-group-unarchive')),
                class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white mt-4 mx-2 flex flex-row justify-center items-center flex-wrap"
              }, [
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-school-group',
                    title: 'rl school group',
                    "aria-hidden": "true"
                  })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('internal_tools.archive_selection_component.unarchive_school_groups')), 1)
              ]),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (menuToggle.value = 'school-unarchive')),
                class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white mt-4 mx-2 flex flex-row justify-center items-center flex-wrap"
              }, [
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-archive-school',
                    title: 'rl archive school',
                    "aria-hidden": "true"
                  })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('internal_tools.archive_selection_component.unarchive_schools')), 1)
              ]),
              _createVNode(_component_router_link, {
                to: "/main/internal-achive#unarchive",
                class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white mt-4 mx-2 flex flex-row justify-center items-center flex-wrap"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_rl_icon, {
                      icon: 'rl-learners-icon',
                      title: 'rl learners icon',
                      "aria-hidden": "true"
                    })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('internal_tools.archive_selection_component.unarchive_learners')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      (menuToggle.value !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (menuToggle.value = '')),
              class: "font-semibold text-gray-600 text-base border-gray-300 border rounded-lg py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white gap-1"
            }, [
              _createElementVNode("span", _hoisted_17, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-small-back-arrow',
                  title: 'rl small back arrow',
                  "aria-hidden": "true"
                })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('internal_tools.archive_selection_component.back')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (menuToggle.value == 'school-group-archive' || menuToggle.value == 'school-group-unarchive')
      ? (_openBlock(), _createBlock(ArchiveSchoolGroupComponent, {
          key: 1,
          actionType: actionType.value,
          onUpdateValue: showInitialComponent
        }, null, 8, ["actionType"]))
      : _createCommentVNode("", true),
    (menuToggle.value == 'school-archive' || menuToggle.value == 'school-unarchive')
      ? (_openBlock(), _createBlock(ArchiveSchoolComponent, {
          key: 2,
          actionType: actionType.value,
          onUpdateValue: showInitialComponent
        }, null, 8, ["actionType"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})